export default __webpack_public_path__ + "static/media/cannabis-customer-house.e31ac6be.svg";